const SEED = 123321
const FACTOR = 49979693

export function generateColor(text: string) {
  const words = text.split(' ').filter((word) => /^\w+/.test(word))
  const hashes = words.reduce((hash, word) => {
    return hash + stringToHash(word)
  }, 0)
  return hashToHexColor(hashes)
}

function stringToHash(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = ((hash << 5) - hash + char * FACTOR) * SEED
    hash = hash & hash // Convert to 32bit integer
  }
  return hash
}

function hashToHexColor(hash: number): string {
  // Convert the hash to a positive number and limit it to 24 bits (for a valid hex color code)
  const color = (hash & 0xffffff).toString(16).toUpperCase()
  // Ensure the hex string is 6 characters long
  return '#' + '000000'.substring(0, 6 - color.length) + color
}
